export const NEPAL_PHONE_COUNTRY_CODE = '+977';
export const NEPAL_PHONE_MAX_LENGTH = 10;

const NEPAL_MOBILE_PATTERN = /^9\d{9}$/u;

export const sanitizeNepalPhoneNumber = (value: string) => {
  const digits = value.replace(/\D/gu, '');
  const nationalNumber =
    digits.startsWith('977') && digits.length > NEPAL_PHONE_MAX_LENGTH
      ? digits.slice(3)
      : digits;

  return nationalNumber.slice(0, NEPAL_PHONE_MAX_LENGTH);
};

export const getNepalPhoneValidationMessage = (value: string) => {
  if (!value) {
    return 'Phone number is required.';
  }

  if (value.length !== NEPAL_PHONE_MAX_LENGTH) {
    return 'Phone number must be 10 digits.';
  }

  if (!NEPAL_MOBILE_PATTERN.test(value)) {
    return 'Phone number must start with 9.';
  }

  return undefined;
};

export const getNepalPhoneNumberFromMetadata = (value: unknown) => {
  if (typeof value !== 'string') {
    return '';
  }

  if (NEPAL_MOBILE_PATTERN.test(value)) {
    return value;
  }

  const match = /^\+977(9\d{9})$/u.exec(value);

  return match?.[1] ?? '';
};
